/*=========================================================================================
  File Name: moduleUserMutations.js
  Description: User Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {

    SET_USER(state, data) {
        state.userList = data.resultBody
        state.count = data.resultCount
    },
    SET_USER_STATUS(state, data) {
        state.userStatus = data.resultBody
    },
    SET_BLOCKED_REASON(state, data) {
        state.blockedReason = data.resultBody
    },
    SET_USER_INFO(state, data) {
        state.userInfo = data
    },
    SET_SUBSCRIPTION_YN(state, data){
        state.subscriptionYn = data.resultBody
    },
    SET_DEVICE_CHANGE_POPUP(state, data){
        state.selectedUser = data
    },
    SET_USERLESS_DEVICES(state, data){
        state.userlessDevices = data.resultBody
    },
    SET_DEVICE_INFO(state, data){
        state.replaceDeviceInfo = data.resultBody
    },
    RESET_DEVICE_INFO(state){
        state.replaceDeviceInfo =  {
            deviceStatus: "",
            deviceUUID: "",
            lastConnectedTime: "",
            promotionStartDateTime: "",
            serviceStatus: "",
            usedSubscribe: "",
            userUUID: ""
        }
    }
}